<template>
    <label class="esesja-modal__wraper__body__label" :for="forId">
        <slot></slot>
    </label>
</template>
<script charset="utf-8">
    export default {
        name: "InputLabel",
        props: {
            forId: {
                type: String,
                required: true,
            },
        },
    }
</script>